// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DodajPolaznika.module.css */
.DodajPolaznika_formContainer__sAjFv {
  display: flex;
  flex-direction: column;
  width: 60%;
  gap: 70px;
  min-height: 450px;
}

.DodajPolaznika_column__aLlhf {
  flex: 1 1;
  padding: 20px;
  margin: 10px;
}

.DodajPolaznika_formFields__hwhi9 {
  display: flex;
  gap: 40px;
}
.DodajPolaznika_formColumn__jGS73 {
  display: flex;
  flex-direction: column;
  gap: 35px;
}
.DodajPolaznika_formGroup__bcCCW {
  display: flex;
  flex-direction: column;
  max-width: 340px;
}

.DodajPolaznika_Label__CEmSO,
.DodajPolaznika_inputField__b48Nr {
  font-family: Inter;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
}
.DodajPolaznika_Label__CEmSO {
  font-weight: 600;
  color: #828d9a;
  margin-bottom: 8px;
}

.DodajPolaznika_inputField__b48Nr {
  height: 30px;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #d8dbdf;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-weight: 500;
  color: #5f6d7e;
}

.DodajPolaznika_inputField__b48Nr::placeholder {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
}

.DodajPolaznika_inputField__b48Nr:focus {
  border: 1px solid #cb9c2d !important;
  outline: none !important;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.DodajPolaznika_PhoneNumber__pR3nQ {
  display: flex;
  flex-direction: row;
}
.DodajPolaznika_inputPhoneImage__IjtoI {
  border-radius: 8px;
}

.DodajPolaznika_customCheckbox__E53wW {
  display: flex;
  align-items: center;
}
.DodajPolaznika_formButtons__GG6zI {
  position: fixed;
  bottom: 15px;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
.DodajPolaznika_cancelButton__dErln {
  width: 164px;
  background: #ebebeb;
  color: #808080;
}

.DodajPolaznika_submitButton__dnzph {
  width: 215px;
  background: #cb9c2d;
  color: white;
}

.DodajPolaznika_disabledButton__wPpQ7 {
  width: 215px;
  background: #cbba92;
  color: white;
}
.DodajPolaznika_cancelButton__dErln,
.DodajPolaznika_submitButton__dnzph,
.DodajPolaznika_disabledButton__wPpQ7 {
  height: 52px;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
}
.DodajPolaznika_submitButton__dnzph,
.DodajPolaznika_cancelButton__dErln:hover {
  cursor: pointer;
}

.DodajPolaznika_error-message__akYUC {
  color: red;
  font-size: 14px;
  margin-top: 4px;
}

.DodajPolaznika_pageTitle__SCsoa {
  font-size: 28px;
  font-weight: 600;
  color: #4d4e4e;
  margin-top: 20px;
  font-family: Inter;
}

.DodajPolaznika_contentContainer__ups3Q {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
  margin: 24px 0 45px 0;
}

.DodajPolaznika_contentContainerText__C-YuF {
  font-weight: 500;
}
.DodajPolaznika_contentContainerInfo__OY5ah {
  font-weight: 600;
}
.DodajPolaznika_contentContainerText__C-YuF,
.DodajPolaznika_contentContainerInfo__OY5ah {
  color: #6e6e6e;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  line-height: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/polaznici/DodajPolaznika.module.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;;EAGE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA;;;EAGE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["/* DodajPolaznika.module.css */\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  width: 60%;\n  gap: 70px;\n  min-height: 450px;\n}\n\n.column {\n  flex: 1;\n  padding: 20px;\n  margin: 10px;\n}\n\n.formFields {\n  display: flex;\n  gap: 40px;\n}\n.formColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 35px;\n}\n.formGroup {\n  display: flex;\n  flex-direction: column;\n  max-width: 340px;\n}\n\n.Label,\n.inputField {\n  font-family: Inter;\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n.Label {\n  font-weight: 600;\n  color: #828d9a;\n  margin-bottom: 8px;\n}\n\n.inputField {\n  height: 30px;\n  padding: 8px 16px;\n  border-radius: 8px;\n  border: 1px solid #d8dbdf;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-weight: 500;\n  color: #5f6d7e;\n}\n\n.inputField::placeholder {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n}\n\n.inputField:focus {\n  border: 1px solid #cb9c2d !important;\n  outline: none !important;\n}\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n.PhoneNumber {\n  display: flex;\n  flex-direction: row;\n}\n.inputPhoneImage {\n  border-radius: 8px;\n}\n\n.customCheckbox {\n  display: flex;\n  align-items: center;\n}\n.formButtons {\n  position: fixed;\n  bottom: 15px;\n  left: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n}\n.cancelButton {\n  width: 164px;\n  background: #ebebeb;\n  color: #808080;\n}\n\n.submitButton {\n  width: 215px;\n  background: #cb9c2d;\n  color: white;\n}\n\n.disabledButton {\n  width: 215px;\n  background: #cbba92;\n  color: white;\n}\n.cancelButton,\n.submitButton,\n.disabledButton {\n  height: 52px;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: none;\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n}\n.submitButton,\n.cancelButton:hover {\n  cursor: pointer;\n}\n\n.error-message {\n  color: red;\n  font-size: 14px;\n  margin-top: 4px;\n}\n\n.pageTitle {\n  font-size: 28px;\n  font-weight: 600;\n  color: #4d4e4e;\n  margin-top: 20px;\n  font-family: Inter;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 50%;\n  margin: 24px 0 45px 0;\n}\n\n.contentContainerText {\n  font-weight: 500;\n}\n.contentContainerInfo {\n  font-weight: 600;\n}\n.contentContainerText,\n.contentContainerInfo {\n  color: #6e6e6e;\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `DodajPolaznika_formContainer__sAjFv`,
	"column": `DodajPolaznika_column__aLlhf`,
	"formFields": `DodajPolaznika_formFields__hwhi9`,
	"formColumn": `DodajPolaznika_formColumn__jGS73`,
	"formGroup": `DodajPolaznika_formGroup__bcCCW`,
	"Label": `DodajPolaznika_Label__CEmSO`,
	"inputField": `DodajPolaznika_inputField__b48Nr`,
	"PhoneNumber": `DodajPolaznika_PhoneNumber__pR3nQ`,
	"inputPhoneImage": `DodajPolaznika_inputPhoneImage__IjtoI`,
	"customCheckbox": `DodajPolaznika_customCheckbox__E53wW`,
	"formButtons": `DodajPolaznika_formButtons__GG6zI`,
	"cancelButton": `DodajPolaznika_cancelButton__dErln`,
	"submitButton": `DodajPolaznika_submitButton__dnzph`,
	"disabledButton": `DodajPolaznika_disabledButton__wPpQ7`,
	"error-message": `DodajPolaznika_error-message__akYUC`,
	"pageTitle": `DodajPolaznika_pageTitle__SCsoa`,
	"contentContainer": `DodajPolaznika_contentContainer__ups3Q`,
	"contentContainerText": `DodajPolaznika_contentContainerText__C-YuF`,
	"contentContainerInfo": `DodajPolaznika_contentContainerInfo__OY5ah`
};
export default ___CSS_LOADER_EXPORT___;
